import { useState } from 'react';
import { Link } from 'react-router';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from '@/components/ui/card';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    setSuccess(false);
    try {
      await api.post('/auth/forgot-password', { email });
      setSuccess(true);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : 'Не удалось отправить письмо. Попробуйте позже.',
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-4">
      <Card className="w-full max-w-md py-10">
        <CardHeader className="text-center px-12">
          <CardTitle className="text-2xl font-bold">Сброс пароля</CardTitle>
          <CardDescription>
            Введите эл. почту, и мы отправим вам ссылку для сброса пароля
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit} className="flex flex-col gap-7">
          <CardContent className="flex flex-col gap-4 px-12">
            {error && (
              <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">
                {error}
              </div>
            )}
            {success ? (
              <p className="rounded-md bg-muted p-3 text-sm text-muted-foreground">
                Если этот email зарегистрирован, вы получите письмо со ссылкой
                для сброса пароля. Проверьте почту.
              </p>
            ) : (
              <div className="flex flex-col gap-2">
                <label htmlFor="email" className="text-sm font-medium">
                  Email
                </label>
                <Input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>
            )}
          </CardContent>
          <CardFooter className="flex flex-col gap-4 px-12">
            {!success && (
              <Button type="submit" className="w-full" disabled={loading}>
                {loading ? 'Отправляем...' : 'Сбросить пароль'}
              </Button>
            )}
            <p className="text-sm text-muted-foreground">
              <Link
              to="/login"
              className="inline-block text-primary border-b border-current/15 hover:border-current/40"
            >
              Вернуться ко входу
            </Link>
            </p>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
